(ns frontend.ux-overhaul.listing.person-counterparty-diligence.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.ux-overhaul.listing.person-counterparty-diligence.event :as person-counterparty-diligence-event]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "person-counterparty-diligence-listing")

(defn- open-person-counterparty-diligence!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/person-counterparty-diligence})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/person-counterparty-diligence
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :person-counterparty-diligence
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-person-counterparty-diligence
                                 :label    (loc/tr :add)
                                 :visible? true
                                 :enabled? true
                                 :event    [::person-counterparty-diligence-event/create-person-counterparty-diligence]}
                                {:id                  :bulk-edit-person-counterparty-diligences
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            (session/has-feature-access? :feature/bulk-edit)
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::person-counterparty-diligence-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-person-counterparty-diligences
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::person-counterparty-diligence-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-person-counterparty-diligences
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::person-counterparty-diligence-event/export-grid {:listing-id listing-id}]}
                                {:id       :export-person-counterparty-diligences-with-persons
                                 :label    (loc/tr :save-as-excel-all-data)
                                 :visible? true
                                 :enabled? true
                                 :event    [::person-counterparty-diligence-event/export-grid-with-persons {:listing-id listing-id}]}]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :counterparty-diligence/person-diligence)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.person-counterparty-diligence/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::person-counterparty-diligence-event/create-person-counterparty-diligence])
         :on-row-clicked           open-person-counterparty-diligence!
         :on-card-clicked          open-person-counterparty-diligence!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/person-counterparty-diligence}]])}))
